import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["SubscribeForm"] */ "/opt/buildhome/repo/src/components/newsletter/subscribe-form.tsx");
